import { ConsentAwareContract } from '@/services/contracts/consent-aware.contract'
import appStore from '@/stores/app.store'

class MouseflowService implements ConsentAwareContract {
  activate(): void | Promise<void> {
    this.loadScript()
  }

  deactivate(): void | Promise<void> {
    this.deleteCookies()
  }

  private loadScript() {
    if (!appStore.state.mouseflowLoaded) {
      const mouseflowId =
        window.location.href.includes('enterprise') ||
        window.location.href.includes('/b2b') ||
        window.location.href.includes('unternehmensportal')
          ? 'd22f1170-fe02-4c99-a8f3-ba493fef1065'
          : '0ab8167c-3dc2-425e-b5c0-692201ee3670'

      appStore.setMouseflowLoaded(true)
      window._mfq = window._mfq || []
      const mf = document.createElement('script')
      mf.type = 'text/javascript'
      mf.defer = true
      mf.src = `//cdn.mouseflow.com/projects/${mouseflowId}.js`
      document.getElementsByTagName('head')[0].appendChild(mf)
    }
  }

  private deleteCookies() {
    const mouseflowId =
      window.location.href.includes('enterprise') ||
      window.location.href.includes('/b2b') ||
      window.location.href.includes('unternehmensportal')
        ? 'd22f1170-fe02-4c99-a8f3-ba493fef1065'
        : '0ab8167c-3dc2-425e-b5c0-692201ee3670'
    document.cookie = `mf_${mouseflowId}=; path=/; expires=Thu, 01 Jan 1900 00:00:00 UTC; SameSite=None; Secure`
  }
}

export default new MouseflowService()
